"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = {
    dataDimension: true
};
module.exports = exports["default"];
//# sourceMappingURL=dataElementGroupSet.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/dataElementGroupSet.js
// module id = 89
// module chunks = 0